import { createClient } from '@supabase/supabase-js'

const supabaseUrl = process.env.REACT_APP_API_URL
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
    auth: {
        autoRefreshToken: true,
        persistSession: true,
    }
})

export async function createPatientRealtimeClient(patientJwt) {
  const client = createClient(supabaseUrl, supabaseAnonKey, {
    global: {
      headers: { Authorization: `Bearer ${patientJwt}` },
    },
    realtime: {
      params: { apikey: supabaseAnonKey },
      headers: { Authorization: `Bearer ${patientJwt}` },
    },
    auth: {
      autoRefreshToken: false,
      persistSession: false,
      storageKey: `patient-realtime-session-${patientJwt.slice(-8)}`,
    },
  });

  // Force the client to use this JWT as its active session
  await client.auth.setSession({
    access_token: patientJwt,
    refresh_token: patientJwt, // dummy — won't be used since autoRefreshToken is false
  });

  return client;
}